export default "__VITE_ASSET__af2e20d2__"